module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0760.378f858b.jpg";